// @flow

import React from 'react';
import styled from 'styled-components';
import SkippableChallenge from './SkippableChallenge';
import { Dots } from 'react-activity';


const StyledContainer = styled.div`
    .absContainer, .loading {
        display: block;
        position: absolute;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
        background: radial-gradient(circle at center, #636363, black 100%);
    }

    .loading {
        display: flex;
        justify-content: center;
        align-items: center;
    }

    iframe.video-iframe {
        background-color: black;
    }
`;


class IframeChallenge extends SkippableChallenge {
    iFrameSource() {
        return this.props.challenge.url;
    }


    render() {
        if (!this.iFrameSource) {
        }

        return (
            <StyledContainer className={`challengeContainer ${this.props.className || ''}`}>
                <div className="absContainer">
                    <iframe
                      width="100%"
                      height="100%"
                      scrolling={this.props.challenge.testMode ? null : "no"}
                      allowFullScreen="true"
                      title="video"
                      frameBorder="0"
                      className="video-iframe"
                      target="_blank"
                      src={this.iFrameSource()}
                    />
                </div>

                {this.state.loading ? <div className="loading"><Dots size={30} /></div> : null}

                {this.skipButton()}
            </StyledContainer>
        );
    }
}


export default IframeChallenge;



// WEBPACK FOOTER //
// ./src/campaign/challenges/external-sdks/IframeChallenge.jsx